module.exports = "<angular-editor [(ngModel)]=\"comentario\" [config]=\"editorConfig\" (ngModelChange)=\"updateComentario()\"></angular-editor>"